import React, { useContext, useEffect } from "react";

// import IconsGallery from "../IconsGallery";
import { AppContext } from "./context/useAppContext";
import { Nav } from "./components/Nav";
import { Gallery } from "./components/Gallery";
import Footer from "./components/Footer";

const App = () => {

    const [appState, setAppState] = useContext(AppContext);

    useEffect(() => {
      // FETCHING ICONS
      const fetchIconsData = async () => {
        const response = await fetch("https://svgiconsdata.netlify.app/icons.json");
        const json = await response.json();
        return json;
      };

       
  
      fetchIconsData()
        .then((data) => {
        
          //setAppState((appState) => ({ ...appState, icons: data }));
          if(data.length>0){
            
              const rootFolders=["All Icons",
              ...new Set(data.map((item)=>item.category)),
            ];
            //console.log(rootFolders)
            setAppState({ 
                ...appState, 
                appIsLoading:false,
                categories:[...rootFolders],
                icons: data,
                selectedCategoryIcons:data,
                
              });
              //console.log("Icons data was loaded...",appState.appIsLoading);
          }
          
        })
        .catch((err) => console.log("Error fetching icons data...", err));
         // eslint-disable-next-line
    }, [appState.appIsLoading]);
  
  return (
    <main className="App">
      <Nav/> 
      <Gallery />
      <Footer/>
    </main>
  );
};

export default App;
